<template>
  <div>
    <h3 class="mt-50 mb-50 text-center text-uppercase text-white">{{ "Login Now" | __t("auth__login-now") }}</h3>

    <b-button
      @click="$emit('continue-with-email-magiclink')"
      data-cy="link-register-magiclink"
      variant="deepblue"
      class="pt-2 pb-2 w-100 rounded"
      :disabled="isLoading"
    >
      <b-icon-envelope-fill class="mr-3" /> {{ "Continue With Link" | __t("auth__continue-with-email-and-magiclink") }}
    </b-button>
    <!--
    <b-button
      @click="$emit('continue-with-email-password')"
      data-cy="link-register-password"
      variant="light"
      class="w-100 mt-3"
      :disabled="isLoading"
      pill
    >
      <b-icon-envelope-fill /> {{ "Continue With Email And Password" | __t("auth__continue-with-email-and-password") }}
    </b-button>
    -->

    <!--  <b-button
      @click="$emit('continue-with-google')"
      data-cy="link-register-google"
      variant="light"
      class="w-100 mt-3"
      :disabled="isLoading"
      pill
    >
      <b-spinner v-if="isLoading" style="width:20px; height: 20px"></b-spinner>
      <span v-else> <b-icon-google /> {{ "Continue With Google" | __t("auth__continue-with-google") }} </span>
    </b-button> -->
  </div>
</template>

<script>
import { BButton, /* BSpinner, */ BIconEnvelopeFill /* BIconGoogle */ } from "bootstrap-vue";

export default {
  name: "LoginSelect",
  components: { BButton, /* BSpinner, */ BIconEnvelopeFill /* BIconGoogle */ },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
